import { createApp } from 'vue'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';
import router from './router'
import firebaseConfig from './config/firebase'
import { initializeApp } from 'firebase/app'
import quasarUserOptions from './quasar-user-options'
import store from './vuex/store';


initializeApp(firebaseConfig);
createApp(App).use(Quasar, quasarUserOptions).use(router).use(store).mount('#app')
